<template>
  <div class="e4s-flex-row e4s-gap--standard e4s-flex-wrap e4s-justify-flex-row-vert-center">
    <span>Following</span>
    <span v-text="followingEventCount === 0 ? 'all' : followingEventCount"></span>
    <span v-text="followingEventCount === 1 ? 'event' : 'events'"></span>
    <slot name="change-following"></slot>
  </div>
</template>
<script setup lang="ts">
import type { CompEvent, FollowingEvents } from '@/components/results/store-comp-results'
import { computed, type PropType } from 'vue'
// import ButtonGenericV2 from '@/common/ui/buttons/button-generic-v2.vue'

const props = defineProps({
  followingEvents: {
    type: Object as PropType<FollowingEvents>,
    required: true
  }
})

// define emit function
const emit = defineEmits<{
  (e: 'shouldFollowEvent', value: { compEvent: CompEvent; isFollowing: boolean }): void
}>()

const followingEventCount = computed<number>(() => {
  if (!props.followingEvents) {
    return 0
  }
  return Object.keys(props.followingEvents).length
})

function shouldFollowEvent(compEvent: CompEvent, isFollowing: boolean) {
  console.log('shouldFollowEvent', compEvent, isFollowing)
  emit('shouldFollowEvent', { compEvent, isFollowing })
}
</script>
